import Badge, { type BadgeScope, type EarnedBadge } from '../model/Badge'

export interface TrophyBadgeItem {
  badge: Badge
  earned: boolean
  earnedAt?: Date
}

export function buildTrophies(
  badges: Badge[],
  earnedBadges: EarnedBadge[],
  scope: BadgeScope,
): TrophyBadgeItem[] {
  const earnedById = new Map(earnedBadges.map((earned) => [earned.badge.id, earned.earnedAt]))
  return badges
    .filter((badge) => badge.scope === scope && badge.isActive)
    .sort((a, b) => Badge.compareByActivityTypeAndValue(a, b))
    .map((badge) => ({
      badge,
      earned: earnedById.has(badge.id),
      earnedAt: earnedById.get(badge.id),
    }))
}
